import React = require('react')
import { Pair, mk_widget, Option } from 'widgets-for-react'
import { List } from 'immutable'
import { Breadcrumb } from '../../drupal/types_and_parser/extra_types.mod'
import { CustomParsedNode } from '../../drupal/types_and_parser/extra_types.mod'
import { ContentType } from '../../../public_site.main.mod'
import { page_header } from './drupal_page_header.mod'
import { t } from 'i18next'
import { countries, departments } from '../application.mod'

export const page = (extra_info: Option<JSX.Element>) => {
  return (breadcrumbs_and_node: Pair<List<Breadcrumb>, Option<CustomParsedNode>>): ContentType => (blocks) => {
    const pageLanguage = document.querySelector('html').getAttribute('lang')
    const parsedNodeLanguage = breadcrumbs_and_node.snd.v.kind === 'r' ? breadcrumbs_and_node.snd.v.v.language : null
    const isCookiePage = (
      (breadcrumbs_and_node.snd.v.kind == "r" && breadcrumbs_and_node.snd.v.v.path?.toLowerCase() == t('CookiesPlaceholder:LinkToCookies')) ||
      (breadcrumbs_and_node.snd.v.kind == "r" && breadcrumbs_and_node.snd.v.v.path?.toLowerCase() == "/site-services/cookie-policy") ||
      (breadcrumbs_and_node.snd.v.kind == "r" && breadcrumbs_and_node.snd.v.v.path?.toLowerCase() == "/site-services/cookie-notice")
  )

    return mk_widget({
      run: (o) => {
        
        return <main
          id="a11y-main"
          className={`main main--${
            breadcrumbs_and_node.snd.v.kind == 'r' ? breadcrumbs_and_node.snd.v.v.bundle : 'default'
          }`}
        >
          <div className="main__inner">
            <article className="page">
              <div className="page__inner" lang={pageLanguage !== parsedNodeLanguage ? parsedNodeLanguage : null}>
                {breadcrumbs_and_node.snd.v.kind == 'r' &&
                  page_header(departments,countries)(breadcrumbs_and_node.fst)(breadcrumbs_and_node.snd.v.v as any).run((_) => null)}
                <div className="page__content">
                  {extra_info.v.kind == 'r' ? extra_info.v.v : null}
                  {!isCookiePage && blocks.run(o)}

                  {/* CUSTOM CODE */}
                  { // Make sure this is a cookie notice page based on the predefined url
                  isCookiePage &&
                    // This will load the cookie-policy from CookiePro
                    <div className="container container--s grid--block">
                      <div id="ot-sdk-cookie-policy"></div>
                      <button id="ot-sdk-btn" className="ot-sdk-show-settings" onClick={() => Optanon.ToggleInfoDisplay()} style={{marginTop:30}}>
                        {t('CookiesPlaceholder:CookieSettings')}
                      </button>
                    </div>
                  }
                  {/* CUSTOM CODE */}

                </div>
              </div>
            </article>
          </div>
        </main>
    }
    })
  }
}
